
import Button from '@/components/common/form/button.vue'
import CheckBox from '@/components/common/form/checkbox.vue'
import useTranslation from '@/composables/use-translation'
import * as TC from '@/constants/translation-constants'
import { defineComponent, onMounted, ref } from 'vue'
import * as Icons from '@/constants/icon-constants'

export default defineComponent({
  name: 'ProposalConfirmation',
  components: { Button, CheckBox },
  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
    confirmationType: {
      type: String,
      required: true,
      default: '',
    },
    buttonLabel: {
      type: String,
      required: true,
      default: '',
    },
  },
  setup() {
    const t = useTranslation()
    const isChecked = ref(false)

    onMounted(() => {
      const modalScrollElement: HTMLElement | null = document.querySelector(
        '.modal-scroll'
      )
      if (modalScrollElement) {
        modalScrollElement.scrollTo({ top: 0 })
      }
    })

    return {
      isChecked,
      angleLeftIcon: Icons.ANGLE_LEFT_ICON,
      t,
      TC,
    }
  },
})
